<micro-lookup domain="pay" obj="ratings" url="/ratings" [key]="ratingId" [link]="link"></micro-lookup>
